import React, { useEffect, useState } from "react";
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";

// Redux
import { useDispatch } from "react-redux";
import { setUserCredentials, setUserScore } from "./Slices/userSlice";
import { resetIndex } from "./Slices/indexSlice";

// Components
import RouteTracker from "./RouteTracker"; // <-- Make sure this exists

// API Endpoints
import { loginApi, registerApi } from "./Api/api";

// Routes
import LoginPage from "./Routes/LoginPage";
import SignupPage from "./Routes/SignupPage";
import SendOtp from "./Components/Otp";
import OtpVerify from "./Components/VerifyOtp";
import Subscribe from "./Components/Subscribe";
import HomePage3 from "./Routes/HomePage3";
import TermsPage from "./Routes/TermsPage";
import PracticeGamePage from "./Routes/PracticeGamePage";
import GameLevels from "./Routes/GameLevels";
import EasyGamePage2 from "./Routes/EasyGamePage2";
import MediumGamePage2 from "./Routes/MediumGamePage2";
import HardGamePage2 from "./Routes/HardGamePage2";
import WinnerPage from "./Routes/WinnerPage";
import LosePage from "./Routes/LosePage";
import Account from "./Routes/Account";
import Deactivation from "./Components/Deactivation";
import Redirect from "./Components/Redirect";
import PromoRedirectPage from "./Components/PromoRedirect";

// const loginUserApi = "http://localhost:5234/loginuser";
// const headerApi = "http://localhost:5234/header";


const loginUserApi = "/loginuser";
const headerApi = "/header";
// Protected Route Wrapper
const ProtectedRoute = ({ element, status }) => {
  return status == 1 ? element : <Navigate to="/subscribe" />;
};

const App = () => {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  const saveToken = (token) => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(0, 0, 0, 0);
    Cookies.set("token", token, { expires: tomorrow });
  };

  const registerThenLogin = async (ani) => {
    console.log("ANI",ani)
    try {
      const password = ani;
      await axios.post(registerApi, { ani, password });
      const loginRes = await axios.post(loginApi, { ani, password });

      if (loginRes?.data?.token) {
        Cookies.set("msisdn",ani)
        saveToken(loginRes.data.token);
        dispatch(setUserCredentials(ani));
        dispatch(setUserScore(parseInt(loginRes?.data?.score || 0, 10)));
        dispatch(resetIndex());
      }
    } catch (err) {
      console.error("Auto register/login failed:", err);
    }
  };




  const authHandler = async () => {
  const msisdn = Cookies.get("msisdn");

  if (msisdn && msisdn!=undefined) {
    try {
      const res = await axios.get(`${loginUserApi}?msisdn=${msisdn}`);
      const resultStatus = Number(res?.data?.status) || 0;
      setStatus(resultStatus);
      if (resultStatus == 1) {
        await registerThenLogin(msisdn);
      }
    } catch {
      setStatus(0);
    }
  } else {
    try {
      const res = await axios.get(headerApi);
      const result = res?.data;
      const resultStatus = Number(result?.status) || 0;
      setStatus(resultStatus)
      if (resultStatus == 1) {
        await registerThenLogin(result?.msisdn);
      } else {
        setStatus(0);
      }

    } catch {
      setStatus(0);
    }
  }
};


  // Reusable auth logic
  // const authHandler = async () => {
  //   const msisdn = Cookies.get("msisdn");

  //   if (msisdn) {
  //     try {
  //       const res = await axios.get(`${loginUserApi}?msisdn=${msisdn}`);
  //       const resultStatus = Number(res?.data?.status) || 0;
  //       setStatus(resultStatus);
  //       if (resultStatus == 1) {
  //         await registerThenLogin(msisdn);
  //       }
  //     } catch {
  //       setStatus(0);
  //     } finally {
  //       setLoading(false);
  //     }
  //   } else {
  //     try {
  //       const res = await axios.get(headerApi);
  //       const result = res?.data;
  //       console.log("RESULT",result)
  //       const resultStatus = Number(result?.status) || 0;
  //        setStatus(1);   
  //        Cookies.set("msisdn", result?.msisdn);
  //        if (resultStatus == 1) {
  //         console.log("MSISDN",result.msisdn)
  //         await registerThenLogin(result?.msisdn);
  //         Cookies.set("msisdn", result?.msisdn);
  //       } else {
  //         setStatus(0);
  //       }
  //     } catch {
  //       setStatus(0);
  //     } finally {
  //       setLoading(false);
  //     }
  //   }
  // };

  // Run on first load
useEffect(() => {
  const timer = setTimeout(() => setLoading(false), 5000); // Show loader for 5s
  authHandler(); // Run authentication
  return () => clearTimeout(timer); // Cleanup
}, []);


  // Re-run if user comes from /otp-validation
  const handlePathChange = (prevPath) => {

     const currentPath = window.location.pathname;
    if (prevPath === "/otp-validation" && currentPath === "/") {
      console.log("🔁 Re-running auth from /otp-validation");
      authHandler();
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <RouteTracker onPathChange={handlePathChange}>
      <Routes>
        <Route path="/" element={<HomePage3 status={status} />} />
        <Route path="/redirect" element={<Redirect status={status} />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/otp" element={<SendOtp />} />
        <Route path="/otp-validation" element={<OtpVerify />} />
        <Route path="/subscribe" element={<Subscribe />} />
        <Route path="/promo" element={<PromoRedirectPage />} />

        <Route path="/terms" element={<ProtectedRoute status={status} element={<TermsPage status={status}  />} />} />
        <Route path="/game/practice" element={<ProtectedRoute status={status} element={<PracticeGamePage status={status} />} />} />
        <Route path="/game/levels" element={<ProtectedRoute status={status} element={<GameLevels status={status} />} />} />
        <Route path="/game/easy" element={<ProtectedRoute status={status} element={<EasyGamePage2 status={status}  />} />} />
        <Route path="/game/medium" element={<ProtectedRoute status={status} element={<MediumGamePage2 status={status} />} />} />
        <Route path="/game/hard" element={<ProtectedRoute status={status} element={<HardGamePage2 status={status} />} />} />
        <Route path="/game/winner" element={<ProtectedRoute status={status} element={<WinnerPage status={status} />} />} />
        <Route path="/game/lose" element={<ProtectedRoute status={status} element={<LosePage status={status} />} />} />
        <Route path="/user/account" element={<ProtectedRoute status={status} element={<Account status={status}  />} />} />
        <Route path="/deactivation" element={<Deactivation />} />
      </Routes>
    </RouteTracker>
  );
};

export default App;



// import React, { useEffect, useState } from "react";
// import { createBrowserRouter, RouterProvider, Navigate, useNavigate } from "react-router-dom";
// import axios from "axios";
// import Cookies from "js-cookie";

// // Redux
// import { useDispatch } from "react-redux";
// import { setUserCredentials, setUserScore } from "./Slices/userSlice";
// import { resetIndex } from "./Slices/indexSlice";
// import { useLocation } from "react-router-dom";

// // API Endpoints
// import { loginApi, registerApi } from "./Api/api";

// // Routes
// import LoginPage from "./Routes/LoginPage";
// import SignupPage from "./Routes/SignupPage";
// import SendOtp from "./Components/Otp";
// import OtpVerify from "./Components/VerifyOtp";
// import Subscribe from "./Components/Subscribe";
// import HomePage3 from "./Routes/HomePage3";
// import TermsPage from "./Routes/TermsPage";
// import PracticeGamePage from "./Routes/PracticeGamePage";
// import GameLevels from "./Routes/GameLevels";
// import EasyGamePage2 from "./Routes/EasyGamePage2";
// import MediumGamePage2 from "./Routes/MediumGamePage2";
// import HardGamePage2 from "./Routes/HardGamePage2";
// import WinnerPage from "./Routes/WinnerPage";
// import LosePage from "./Routes/LosePage";
// import Account from "./Routes/Account";
// import Deactivation from "./Components/Deactivation";

// // API
// const loginUserApi = "/loginuser";
// const headerApi = "/header";

// // Protect Routes
// const ProtectedRoute = ({ element, status }) => {
//   return status === 1 ? element : <Navigate to="/subscribe" />;
// };

// const App = () => {
//   const [status, setStatus] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const dispatch = useDispatch();


//   // Save token using js-cookie until midnight
//   const saveToken = (token) => {
//     const tomorrow = new Date();
//     tomorrow.setDate(tomorrow.getDate() + 1);
//     tomorrow.setHours(0, 0, 0, 0);
//     Cookies.set("token", token, { expires: tomorrow });
//   };

//   // Auto-register and login
//   const registerThenLogin = async (ani) => {
//     try {
//       const password = ani;

//       const registerRes = await axios.post(registerApi, { ani, password });
//       console.log("Register response:", registerRes?.data);

//       const loginRes = await axios.post(loginApi, { ani, password });
//       console.log("Login response:", loginRes?.data);

//       if (loginRes?.data?.token) {
//         saveToken(loginRes.data.token);

//         dispatch(setUserCredentials(ani));
//         dispatch(setUserScore(parseInt(loginRes?.data?.score || 0, 10)));
//         dispatch(resetIndex());
//       }
//     } catch (err) {
//       console.error("Auto register/login failed:", err);
//     }
//   };


 
//   useEffect(() => {
//     const msisdn = Cookies.get("msisdn");
//     console.log("Cookies msisdn:", msisdn);

//     if (msisdn) {
//       axios
//         .get(`${loginUserApi}?msisdn=${msisdn}`)
//         .then(async (res) => {
//           const resultStatus = Number(res?.data?.status) || 0;
//           console.log("Status from loginUser:", resultStatus);
//           setStatus(resultStatus);
//           if (resultStatus === 1) {
//             await registerThenLogin(msisdn);
//           }
//         })
//         .catch(() => setStatus(0))
//         .finally(() => setLoading(false));
//     } else {
//       axios
//         .get(headerApi)
//         .then(async (res) => {
//           const result = res?.data;
//           const resultStatus = Number(result?.status) || 0;
//           if (resultStatus === 1 && result?.msisdn) {
//             Cookies.set("msisdn", result.msisdn);
//             setStatus(1);
//             await registerThenLogin(result.msisdn);
//           } else {
//             setStatus(0);
//           }
//         })
//         .catch(() => setStatus(0))
//         .finally(() => setLoading(false));
//     }
//   }, []);

//   if (loading) return <div>Loading...</div>;

//   // ROUTER
//   const router = createBrowserRouter([
//  { path: "/", element: <HomePage3 status={status} /> },
//  { path: "/redirect", element: <HomePage3 status={status} /> },


//     { path: "/login", element: <LoginPage /> },
//     { path: "/signup", element: <SignupPage /> },
//     { path: "/otp", element: <SendOtp /> },
//     { path: "/otp-validation", element: <OtpVerify /> },
//     { path: "/subscribe", element: <Subscribe /> },
//     {
//       path: "/terms",
//       element: <ProtectedRoute status={status} element={<TermsPage />} />,
//     },
//     {
//       path: "/game/practice",
//       element: <ProtectedRoute status={status} element={<PracticeGamePage />} />,
//     },
//     {
//       path: "/game/levels",
//       element: <ProtectedRoute status={status} element={<GameLevels />} />,
//     },
//     {
//       path: "/game/easy",
//       element: <ProtectedRoute status={status} element={<EasyGamePage2 />} />,
//     },
//     {
//       path: "/game/medium",
//       element: <ProtectedRoute status={status} element={<MediumGamePage2 />} />,
//     },
//     {
//       path: "/game/hard",
//       element: <ProtectedRoute status={status} element={<HardGamePage2 />} />,
//     },
//     {
//       path: "/game/winner",
//       element: <ProtectedRoute status={status} element={<WinnerPage />} />,
//     },
//     {
//       path: "/game/lose",
//       element: <ProtectedRoute status={status} element={<LosePage />} />,
//     },
//     {
//       path: "/user/account",
//       element: <ProtectedRoute status={status} element={<Account />} />,
//     },
//      {
//   path: "/deactivation",
//   element: <Deactivation />,
// }

//   ]);

//   return <RouterProvider router={router} />;
// };

// export default App;




// WORKING BEFORE INTEGRATION

// import React, { useEffect } from "react";
// import { createBrowserRouter, RouterProvider } from "react-router-dom";
// import Auth from "./Components/Auth/Auth";
// import LoginPage from "./Routes/LoginPage";
// import WinnerPage from "./Routes/WinnerPage";
// import LosePage from "./Routes/LosePage";
// import SignupPage from "./Routes/SignupPage";
// import EasyGamePage2 from "./Routes/EasyGamePage2";
// import MediumGamePage2 from "./Routes/MediumGamePage2";
// import HardGamePage2 from "./Routes/HardGamePage2";
// import GameLevels from "./Routes/GameLevels";
// import PracticeGamePage from "./Routes/PracticeGamePage";
// import TermsPage from "./Routes/TermsPage";
// import HomePage3 from "./Routes/HomePage3";
// import Account from "./Routes/Account";
// import AuthWithScore from "./Components/Auth/AuthWithScore";
// import Subscribe from "./Components/Subscribe";
// import SendOtp from "./Components/Otp";
// import OtpVerify from "./Components/VerifyOtp";

// const App = () => {
//   const router = createBrowserRouter([
//     {
//       path: "/login",
//       element: <LoginPage />,
//     },
//     {
//       path: "/signup",
//       element: <SignupPage />,
//     },
//      {
//       path: "/otp",
//       element: <SendOtp />,
//     },
//      {
//       path: "/otp-validation",
//       element: <OtpVerify />,
//     },
//     {
//       path: "/",
//       element: (
//           <HomePage3 />
//         // <Auth>
//         //   <HomePage3 />
//         // </Auth>
//       ),
//     },

//      {
//       path: "/subscribe",
//       element: (
//           <Subscribe />
      
//       ),
//     },
//     {
//       path: "/terms",
//       element: (
//         <Auth>
//           <TermsPage />
//         </Auth>
//       ),
//     },
//     {
//       path: "/game/practice",
//       element: (
//         <Auth>
//           <PracticeGamePage />
//         </Auth>
//       ),
//     },
//     {
//       path: "/game/levels",
//       element: (
//         <Auth>
//           <AuthWithScore>
//             <GameLevels />
//           </AuthWithScore>
//         </Auth>
//       ),
//     },
//     {
//       path: "/game/easy",
//       element: (
//         <Auth>
//           <AuthWithScore>
//             <EasyGamePage2 />
//           </AuthWithScore>
//         </Auth>
//       ),
//     },
//     {
//       path: "/game/medium",
//       element: (
//         <Auth>
//           <AuthWithScore>
//             <MediumGamePage2 />
//           </AuthWithScore>
//         </Auth>
//       ),
//     },
//     {
//       path: "/game/hard",
//       element: (
//         <Auth>
//           <AuthWithScore>
//             <HardGamePage2 />
//           </AuthWithScore>
//         </Auth>
//       ),
//     },
//     {
//       path: "/game/winner",
//       element: (
//         <Auth>
//           <WinnerPage />
//         </Auth>
//       ),
//     },
//     {
//       path: "/game/lose",
//       element: (
//         <Auth>
//           <LosePage />
//         </Auth>
//       ),
//     },
//     {
//       path: "/user/account",
//       element: (
//         <Auth>
//           <Account />
//         </Auth>
//       ),
//     },
//   ]);

//   return <RouterProvider router={router}></RouterProvider>;
// };

// export default App;
